/**
 * Template Service
 * 
 * Handles template-related API calls for regular users.
 * Allows users to view available templates and add them to their categories.
 * 
 * @validates Requirements 6.1, 6.2, 6.3 - Template availability and re-addition
 */

import api from './api';
import { CategoryTemplate, Category, ApiResponse } from '@budgira/shared';

export const templateService = {
  /**
   * Get templates available for the current user
   * Returns templates that the user doesn't already have as categories
   * 
   * @validates Requirement 6.1, 6.2
   */
  async getAvailableTemplates(): Promise<ApiResponse<CategoryTemplate[]>> {
    const response = await api.get<ApiResponse<CategoryTemplate[]>>('/templates/available');
    return response.data;
  },

  /**
   * Add a template to the user's categories
   * Creates a copy of the template as a user category
   * 
   * @validates Requirement 6.3
   */
  async addTemplate(templateId: string): Promise<ApiResponse<Category[]>> {
    const response = await api.post<ApiResponse<Category[]>>(`/templates/${templateId}/add`);
    return response.data;
  },
};

export default templateService;
